import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { ConciergeActions } from './concierge.actions'
import { catchError, map, exhaustMap, of, tap } from 'rxjs'
import { Router } from '@angular/router'
import { ConciergeAuthService } from '../../auth/admin-auth.service'

@Injectable()
export class ConciergeEffects {
	constructor(
		private actions$: Actions,
		private conciergeAuthService: ConciergeAuthService,
		private router: Router
	) {}

	loginConciergeUser$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ConciergeActions.loginConciergeUser),
			exhaustMap(({ username, password, partnerId }) => {
				return this.conciergeAuthService.login({ username, password, partnerId }).pipe(
					tap(response => {
						this.conciergeAuthService.setToken(response.access_token.token)
						localStorage.setItem('CONCIERGE_USER', JSON.stringify(response))
					}),
					map(response => ConciergeActions.loginConciergeUserSuccess({ conciergeUser: response })),
					catchError(err =>
						of(
							ConciergeActions.loginConciergeUserFailure({
								error: err?.error?.message || 'Erro desconhecido',
							})
						)
					)
				)
			})
		)
	)

	// Roteamento fora do observable para manter efeito puro
	redirectOnLoginSuccess$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(ConciergeActions.loginConciergeUserSuccess),
				tap(() => {
					this.router.navigate(['/concierge/painel-de-controle'])
				})
			),
		{ dispatch: false }
	)
}
